import { render, staticRenderFns } from "./FriendManagementGroupStatistics.vue?vue&type=template&id=5561baea&scoped=true"
import script from "./FriendManagementGroupStatistics.vue?vue&type=script&lang=ts"
export * from "./FriendManagementGroupStatistics.vue?vue&type=script&lang=ts"
import style0 from "./FriendManagementGroupStatistics.vue?vue&type=style&index=0&id=5561baea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561baea",
  null
  
)

export default component.exports